// Description: This file is responsible for the routes of the application, it is here that the routes are defined and the components are called according to the route.
// Updated: 14/08/2025
// Author: Vitor Jesus

// React
import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Components and Functions for the Project
import LoginForm from './pages/Login';
import LoginRecoveryPage from './pages/Login/LoginRecoveryPage';
import Reports from './pages/Dashboard/reports';
import ChannelPage from './pages/Channel';
import ChannelPageAdd from './pages/Channel/ChannelPageAdd';
import ChannelPageAddWhatsApp from './pages/Channel/ChannelPageAddWhatsApp';
import ChannelPageAddWhatsAppBusiness from './pages/Channel/ChannelPageAddWhatsAppBusiness';
import ChannelPageConfig from './pages/Channel/ChannelPageConfig';
import Erro from './pages/Error';
import Templates from './pages/Templates';
import TemplateAdd from './pages/Templates/TemplatePageAdd';
import TemplateView from './pages/Templates/TemplateViewPage';
import PageOptionsChannel from './pages/Templates/TemplatePageOptionsChannel';
import Sheets from './pages/Sheets';
import PageAddSheets from './pages/Sheets/addSheets';
import CampaignPage from './pages/Campaigns';
import EditTemplate from './pages/Templates/EditTemplate';
import ConfigurationPage from './pages/Configuration';
import PlanShowCase from './pages/Plans';
import FinishRegister from './pages/FinishRegister/index';
import AddSheetsOptions from './pages/Sheets/addSheetsOptions';
import PageAddApis from './pages/Sheets/addSheetsAPI';
import ChannelPageAddSMS from './pages/Channel/ChannelPageAddSMS';
import SessionExpired from './pages/SessionExpired/SessionExpired';
import PageAddExcel from './pages/Sheets/addSheetsExcel';
import ChannelPageAddEmail from './pages/Channel/ChannelPageAddEmail';
import CampaignInfo from './pages/Campaigns/CampaignInfo';
import AccessDenied from './pages/AccessDenied/AccessDenied';
import use123zapStore from './context/123zapStore';
import IntegrationsPage from './pages/Integrations';
import AddIntegration from './pages/Integrations/AddIntegration';
import PageAddIntegration from './pages/Sheets/addSheetsIntegration';
import AddSheetsIntegrationInvoice from './pages/Sheets/addSheetsIntegrationInvoice';
import SignUp from './pages/SignUp';
import VerifyEmailPage from './pages/VerifyEmail/VerifyEmail';
import CallbackPage from './pages/Login/CallbackPage';
import TemplatePageAddWhatsAppAPI from './pages/Templates/TemplatePageAddWhatsAppAPI';
import EditWhatsAppAPI from './pages/Templates/EditWhatsAppAPI';
import FacebookLogin from './pages/FacebookLogin/index';
import FormEmailNew from './pages/Templates/TemplateEmailNew';
import EditEmailTemplate from './pages/Templates/EditEmailTemplate';
import { jwtDecode } from 'jwt-decode';
import CampaignPageAdd from './pages/Campaigns/CampaignPageAdd';

// Render the Component
function App() {

  const userAuthenticated = use123zapStore((state) => state.userAuthenticated);

  useEffect(() => {
    const token = localStorage.getItem('idToken');

    if (userAuthenticated === true) {
      const decodedToken = jwtDecode(token);

      const isEmailVerified = decodedToken['email_verified'];
      const isAlreadyOnVerificationPage = window.location.pathname === '/verificar-email';

      if (!isEmailVerified && !isAlreadyOnVerificationPage) {
        window.location.pathname = `/verificar-email`;
      }
    }

  }, [userAuthenticated]);

  return (

    <Routes>
      <Route path="/" element={userAuthenticated ? <Navigate to="/painel" /> : <LoginForm />} />
      <Route path="/logout" element={<SessionExpired />} />

      {!userAuthenticated && (
        <>
          <Route path='/esqueci-senha' element={<LoginRecoveryPage />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/cadastro" element={<SignUp />} />
          <Route path="/callback" element={<CallbackPage />} />
        </>
      )}

      {userAuthenticated && (
        <>
          <Route path="/painel" element={<Reports />} />
          <Route path="/canais" element={<ChannelPage />} />
          <Route path="/canais/adicionar" element={<ChannelPageAdd />} />
          <Route path="/canais/adicionar/whatsapp" element={<ChannelPageAddWhatsApp />} />
          <Route path="/canais/adicionar/whatsapp-business" element={<ChannelPageAddWhatsAppBusiness />} />
          <Route path="/canais/adicionar/sms" element={<ChannelPageAddSMS />} />
          <Route path="/canais/adicionar/email" element={<ChannelPageAddEmail />} />
          <Route path="/canais/configurações" element={<ChannelPageConfig />} />
          <Route path="/modelos" element={<Templates />} />
          <Route path="/modelos/canal" element={<PageOptionsChannel />} />
          <Route path="/permissão-facebook" element={<FacebookLogin />} />
          <Route path='/modelos/canal/whatsapp-web' element={<TemplateAdd typeChannel='WhatsApp' />} />
          <Route path='/modelos/canal/whatsapp-api' element={<TemplatePageAddWhatsAppAPI />} />
          <Route path='/modelos/canal/email' element={<FormEmailNew />} />
          <Route path='/modelos/canal/sms' element={< TemplateAdd typeChannel='SMS' />} />
          <Route path='/modelos/editar' element={<EditTemplate />} />
          <Route path='/modelos/editar/whatsapp-api' element={<EditWhatsAppAPI />} />
          <Route path='/modelos/email/editar' element={<EditEmailTemplate />} />
          <Route path="/listagens" element={<Sheets />} />
          <Route path="/listagens/adicionar" element={<AddSheetsOptions />} />
          <Route path="/listagens/adicionar/google" element={<PageAddSheets />} />
          <Route path="/listagens/adicionar/api" element={<PageAddApis />} />
          <Route path="/listagens/adicionar/excel" element={<PageAddExcel />} />
          <Route path="/listagens/adicionar/:integration" element={<PageAddIntegration />} />
          <Route path="/listagens/adicionar/:integration/faturas em aberto" element={<AddSheetsIntegrationInvoice />} />
          <Route path="/campanhas" element={<CampaignPage />} />
          <Route path="/campanhas/visualizar" element={<CampaignInfo />} />
          <Route path="/template/view" element={<TemplateView />} />
          <Route path="/campanhas/adicionar" element={<CampaignPageAdd />} />
          <Route path="/integrações" element={<IntegrationsPage />} />
          <Route path="/integrações/adicionar" element={<AddIntegration />} />
          <Route path="/configurações" element={<ConfigurationPage />} />
          <Route path="/acesso-restrito" element={<AccessDenied />} />
          <Route path='/finalizar-cadastro' element={<FinishRegister />} />
          <Route path="/planos" element={<PlanShowCase />} />
          <Route path="/verificar-email" element={<VerifyEmailPage />} />


          <Route path="*" element={<Erro />} />
        </>
      )}
    </Routes>
  );
}

export default App;